import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { initialHotelRules } from "../../const";

export const useHotelRules = () => {
  const [isCreating, setIsCreating] = useState(false);

  const [rulesData, setRulesData] = useState(initialHotelRules);

  useEffect(() => {
    fetchHotelRules();
  }, []);

  const fetchHotelRules = async () => {
    try {
      const response = await axios.get("/api/hotelrules/get");
      if (response.data && Object.keys(response.data).length > 0) {
        setRulesData(response.data);
        setIsCreating(false); // Rules already exist, no need to create
      } else {
        setIsCreating(true); // No rules exist, show create option
      }
    } catch (error) {
      console.error("Error fetching hotel rules:", error);
      message.error("Failed to fetch hotel rules.");
    }
  };

  const handleInputChange = (field, value) => {
    setRulesData({ ...rulesData, [field]: value });
  };

  const handleSaveRules = async () => {
    try {
      if (isCreating) {
        // Create new rules
        await axios.post("/api/hotelrules/create", rulesData);
        message.success("Hotel rules created successfully!");
        setIsCreating(false);
      } else {
        // Update existing rules
        await axios.put("/api/hotelrules/update", rulesData);
        message.success("Hotel rules updated successfully!");
      }
    } catch (error) {
      console.error("Error saving hotel rules:", error);
      message.error("Failed to save hotel rules.");
    }
  };
  return {
    rulesData,
    isCreating,
    handleInputChange,
    handleSaveRules,
  };
};
